import React from "react";
import image from '../Assets/ThankYou.png'
import { LayoutSingleColumn, Page } from "../../../components";
import TopbarContainer from "../../TopbarContainer/TopbarContainer";
import FooterContainer from '../../FooterContainer/FooterContainer';
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useIntl } from "react-intl";
import css from "./ThankYouSection.module.css"

const ThankYouPage = () => {
    const history = useHistory()
    const intl=useIntl()
    console.log('data>122', history?.location?.search?.includes('state'))
    // Thanks for updates. You are closer to your goal than ever!
    return (
        <Page title="" scrollingDisabled={false}>
            <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
                <div className="thank_you_container">
                    <h2 className={history?.location?.search?.includes('state') ? "thank_you_header1" : "thank_you_header"}>{history?.location?.search?.includes('state') ? intl.formatMessage({id:'Listing.Thankyou.thanksUpdateLabel'}) : intl.formatMessage({id:'Listing.Thankyou.journeyLabel'})}</h2>
                    {
                        !history?.location?.search?.includes('state') && (
                            <p className={css.labelDescription}>{intl.formatMessage({id: "Listing.Thankyou.journeyLabelDescription"})}</p>
                        )
                    }
                    <div className="thank_you_img_container">
                        <img src={image} alt='thank-you' />
                    </div>


                </div>
            </LayoutSingleColumn>
        </Page>
    )

}
export default ThankYouPage
